// extracted by mini-css-extract-plugin
export default {"popover-menu":"popoverMenu_popover-menu__crcXf","menu-body":"popoverMenu_menu-body__4kQDt","menu-items":"popoverMenu_menu-items__jUKgI","menu-item":"popoverMenu_menu-item__LkVWo"};